/**
 * @file localization related utility functions
 */

/**
 * get locale from context or env.
 * Note: The returned value of this function is not a typical locale. A typical locale = language + region, while this
 * function might return "en" and it's from document.documentElement.lang
 * @param {Object} serverContext Server Context
 * @returns {String} locale.
 */
export const getContextLocale = (serverContext = {}) => (
  serverContext.CurrentLocale
  || document.documentElement.lang
  || navigator.language
  || 'en-us'
);
